import * as z from 'zod';
import { createRoute } from '@tanstack/react-router';
import { ArticleView } from './Article';
import { LangEnum } from '@/constants';

const articleSearchSchema = z.object({
	lang: LangEnum,
});

export const path = 'article/$id';

export function getRoute({ parentRoute }: RouteParams) {
	return createRoute({
		getParentRoute: () => parentRoute,
		validateSearch: articleSearchSchema,
		path,
		component: ArticleView,
	});
}

interface RouteParams {
	parentRoute: any;
}
